import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { fakeAsync } from '@angular/core/testing';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs-compat/Subscription';
import { DataService } from 'src/app/data.service';
import { ModalService } from 'src/app/modal.service';

declare var Recorder: any
declare var window: any;

@Component({
  selector: 'app-audio-recorder',
  templateUrl: './audio-recorder.component.html',
  styleUrls: ['./audio-recorder.component.scss']
})

export class AudioRecorderComponent implements OnInit, OnDestroy {

  public URL: any;
  public gumStream: any;
  public rec: any;
  public input: any;
  public AudioContext: any;
  public audioContext: any;
  public recordButton: any;
  public stopButton: any;
  public pauseButton: any;
  public playButton: any;
  public readyState: any;
  public recordingsList: any;
  public constraints: any;
  public recordingCount: number = 0;
  public isPlaying = false;
  public seconds = 0;
  public secondTimer;
  public secondString = "";
  public minuteString = "";
  public isSaving = false;
  public isSaved = false;
  public isRecording = false;
  public isLoading = false;
  public questionId = "";
  public sessionId = "";
  public setQuestionSession;
  public recordingText = "";
  public stringifyTimerTimer;
  public cacheBuster = "";

  private loadAnswersSubscription : Subscription;

  constructor(
    private http: HttpClient,
    public dataSvc: DataService,
    public translate: TranslateService,
    public modalService: ModalService
    ) { 
      var exisitingLangauge = localStorage.getItem("userslanguage");
      if (exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== "") {
        this.dataSvc.changeLangauge(exisitingLangauge);
      }
      else {
        this.translate.setDefaultLang("en");
        this.translate.use("en");
      }

      this.loadAnswersSubscription = this.dataSvc.getLoadOralAnswersEvent().subscribe(()=>{
        this.loadAnswers();
      });
    }

  ngOnInit() {
    this.URL = window.URL || window.webkitURL;
    this.AudioContext = window.AudioContext || window.webkitAudioContext;
    this.recordingCount = 0;
    this.bindObjects();
    this.seconds = 0;
    this.loadAnswers();
    this.resetCacheBuster();
  }

  ngOnDestroy(): void { 
    if (this.isRecording)
      this.stopRecording();
  }

  loadAnswers() { 

    if(this.dataSvc.previewMode)
      return;
    this.recordingText = localStorage.getItem("userslanguage") == "nl" ? 'Opname opgeslagen' : 'Recording saved';

    this.isLoading = true;
    var _sessionId = this.dataSvc.currentExam.Session.SessionId.toString();
    var _questionId = this.dataSvc.currentQuestion.SessionQuestion.QuestionId.toString();

    if (this.questionId != _questionId && this.questionId != "") {
      if (this.isRecording)
        this.stopRecording();
    }

    clearTimeout(this.setQuestionSession);
    this.setQuestionSession = setTimeout(() => {
      this.questionId = _questionId;
      this.sessionId = _sessionId;
      this.pullOralAnswer();
    }, 1000);
  }

  pullOralAnswer() {
    this.getRecording();
  }

  setTimerStrings() { 
    var secs = this.seconds;

    if (isNaN(secs))
      secs = 0;

    var mins = Math.floor(secs/60);
    var secs = secs - (mins*60);

    this.secondString = secs.toString();
    this.minuteString = mins.toString();

    if (this.secondString.length == 1)
      this.secondString = "0" + this.secondString;
    if (this.minuteString.length == 1)
      this.minuteString = "0" + this.minuteString;
  }

  bindObjects() {
    this.recordButton = document.getElementById("recordButton");
    this.stopButton = document.getElementById("stopButton");
    this.pauseButton = document.getElementById("pauseButton");
    this.playButton = document.getElementById("playRecording");
    this.recordingsList = document.getElementById("recordingsList");
  }

  startRecording() {
    var confirmMessage = "Recording new audio will delete any existing audio for this question.";
        if (localStorage.getItem("userslanguage") == "nl")
            confirmMessage = "Als u nieuwe audio opneemt, wordt alle bestaande audio voor deze vraag verwijderd.";

    if(this.dataSvc.previewMode)
      return;
    

    if (this.isSaved) {
      // if (!confirm(confirmMessage)) { 
      //   return;
      // }
      let confirmed = false;
      this.modalService.openConfirmModal(confirmMessage).then(cnf => {
        confirmed = cnf;
      });
      if (!confirmed) { 
        return;
      }
    }

    this.dataSvc.hideLoading("");
    this.isRecording = true;
    this.isSaving = false;
    this.isSaved = false;
    this.seconds = 0;
    this.setTimerStrings();
    this.bindObjects();
    this.constraints = { audio: true, video:false }
    this.recordButton.disabled = true;
    this.stopButton.disabled = false;
    this.pauseButton.disabled = false;
    this.playButton.disabled = true;
    clearInterval(this.secondTimer);
    this.setTimerStrings();
    navigator.mediaDevices.getUserMedia(this.constraints).then((stream) => {
      this.audioContext = new AudioContext();
      document.getElementById("formats").innerHTML = "Format: 1 channel pcm @ " + this.audioContext.sampleRate/1000 + "kHz"
      this.gumStream = stream;
      this.input = this.audioContext.createMediaStreamSource(stream);
      this.rec = new Recorder(this.input,{numChannels:1})
      this.rec.record();
      setTimeout(() => {
        this.secondTimer = setInterval(() => {
          this.seconds = this.seconds + 1;
          this.setTimerStrings();
        }, 1000);
      });
    }).catch((err) => {
        this.recordButton.disabled = false;
        this.stopButton.disabled = true;
        this.pauseButton.disabled = true;
        this.playButton.disabled = true;
    });
  }

  pauseRecording() {
    if(this.dataSvc.previewMode)
      return;

    this.bindObjects();
    if (this.rec.recording) {
      this.rec.stop();
      this.pauseButton.innerHTML = "Resume";
    } else {
      this.rec.record()
      this.pauseButton.innerHTML = "Pause";
    }
  }

  resetCacheBuster() { 
      this.cacheBuster = Date.now().toString(36) + Math.random().toString(36).substring(2);
  }

  stopRecording() {
    if(this.dataSvc.previewMode)
      return;

    if (this.isPlaying) {
      this.setNotPlaying();
    } else {
      if (this.isRecording) {
        this.resetCacheBuster();
        clearInterval(this.secondTimer);
        this.recordingCount ++;
        this.bindObjects();
        this.stopButton.disabled = true;
        this.recordButton.disabled = false;
        this.playButton.disabled = false;
        this.pauseButton.disabled = true;
        this.pauseButton.innerHTML = "Pause";
        this.rec.stop();
        this.gumStream.getAudioTracks()[0].stop();
        this.rec.exportWAV((b) => { this.createDownloadLink(b) });
      }
      this.isRecording = false;
      setTimeout(() => {
        try {
          var duration = Math.floor(this.getPlayer().duration);
          this.seconds = duration;
        } catch(ex) {
          this.seconds = 0;
        }
        this.setTimerStrings();
      }, 1000);
    }
  }

  getRecording(): void {
    if(this.dataSvc.previewMode)
      return;

    var xhr = this.createCORSRequest('GET', this.dataSvc.environment + "/Audio/GetEntireAudio/"+ this.sessionId +"/" + this.questionId);
    const fd = new FormData();

    xhr.onreadystatechange = (res) => {
      if (xhr.readyState === 4) {
        var response = JSON.parse(xhr.responseText);
        if (response.exists) {
          this.bindObjects();
          var recordingUrl = response.url ;
          this.isSaved = true;
          this.recordingCount ++;
          this.playButton.disabled = false;
          this.buildPlayer(recordingUrl + "?v=" + this.cacheBuster);
        }
        else {
          this.bindObjects();
          this.isSaved = false;
          this.recordingCount = 0;
          this.playButton.disabled = true;
          if (this.recordingsList != null && this.recordingsList != undefined)
            this.removeChilds(this.recordingsList);
        }

        this.bindObjects();
        this.stopButton.disabled = true;
        this.recordButton.disabled = false;
        this.pauseButton.disabled = true;
        this.pauseButton.innerHTML = "Pause";

        this.isLoading = false;
      }
    }

    xhr.send(fd);
    
  }

  upload(file: File): void {
    if(this.dataSvc.previewMode)
      return;
      
    this.isSaving = true;
    this.dataSvc.showLoading(localStorage.getItem("userslanguage") == "nl" ? 'Opname opslaan: even geduld a.u.b.' : 'Saving recording: please wait');
    var xhr = this.createCORSRequest('POST', this.dataSvc.environment + "/Audio/UploadEntireAudio/"+ this.sessionId +"/" + this.questionId);
    const fd = new FormData();

    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        this.isSaving = false;
        this.isSaved = true;
        this.dataSvc.currentExam.Questions.forEach(q => {
          if (q.SessionQuestion.QuestionId == this.questionId) {
            q.Result.Selection = "Answered";
          }
        });
      }
      this.dataSvc.hideLoading("");
    }

    fd.append('file', file);
    xhr.send(fd);
    
  }

  createCORSRequest(method, url) {
    var xhr = new XMLHttpRequest();
    xhr.withCredentials = false;
    xhr.open(method, url, true);
    return xhr;
  }

  removeChilds(parent: any)  {
      while (parent.lastChild) {
          parent.removeChild(parent.lastChild);
      }
  };

  buildPlayer(url) { 
    this.bindObjects();

    if (this.recordingsList != null && this.recordingsList != undefined)
      this.removeChilds(this.recordingsList);

    var au = document.createElement('audio');
    var li = document.createElement('li');
    var link = document.createElement('a');
    var filename = new Date().toISOString();
    au.controls = true;
    au.src = url;
    link.href = url;
    link.download = filename + ".wav";
    link.innerHTML = "Save to disk";
    li.appendChild(au);
    li.appendChild(document.createTextNode(filename + ".wav"))
    li.appendChild(link);
    li.appendChild(document.createTextNode (" "));
    this.recordingsList.appendChild(li);
    this.setupPlayerEvents(this.getPlayer());

    clearInterval(this.stringifyTimerTimer);
    this.stringifyTimerTimer = setInterval(() => {
      if (!this.isRecording)
      {
        try {
          var duration = Math.floor(this.getPlayer().duration);
          this.seconds = duration;
        } catch(ex) {
          this.seconds = 0;
        }
        this.setTimerStrings();
      }
    }, 1000);
  }

  createDownloadLink(blob) {
    var url = URL.createObjectURL(blob);
    this.buildPlayer(url);
    this.upload(blob);
    this.setupPlayerEvents(this.getPlayer());
  }

  playRecording() { 
    this.setPlaying();
  }

  getPlayer() { 
    var auds = document.getElementsByTagName("audio");
    var aud = auds[auds.length-1];
    return aud;
  }

  setupPlayerEvents(aud) { 
    aud.removeEventListener("play", () => { this.setPlaying() });
    aud.addEventListener("play", () => { this.setPlaying() });
    aud.removeEventListener("ended", () => { this.setNotPlaying() });
    aud.addEventListener("ended", () => { this.setNotPlaying() });
  }

  setPlaying() { 
    var aud = this.getPlayer()
    aud.play();
    this.setupPlayerEvents(aud);

    this.isPlaying = true;
    this.playButton.disabled = true;
    this.recordButton.disabled = true;
    this.stopButton.disabled = false;
  }
  
  setNotPlaying() {
    var aud = this.getPlayer();
    aud.pause();
	  aud.currentTime = 0.0;
    this.setupPlayerEvents(aud);

    this.isPlaying = false;
    this.playButton.disabled = false;
    this.recordButton.disabled = false;
    this.stopButton.disabled = true;
  }
}